// extracted by mini-css-extract-plugin
module.exports = {"root":"MessagesList_root__12jGQ","header":"MessagesList_header__1nEjM","chat":"MessagesList_chat__3Holu"};